import { Service } from './mainService'

const termoService = {
    baixarTermo,
    aceitarTermo,
}

async function aceitarTermo(idTermo) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_USERS_API + "/TermoAceitacao/" + idTermo);
        return response;
    } catch (e) {
        return e.response;
    }
}

async function baixarTermo(data) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/TermoAceitacao/" + data, { responseType: "blob" });
        return response;
    } catch (e) {
        return e.response;
    }
}

export default termoService;